import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import '../css/navbar.css';

import logo from '../images/justlogo500.png';

import MiniUser from './MiniUser.jsx'

const Navbar = ({ onLogout }) => {

  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenMenu = () => {
    if (menuOpen) {
      setMenuOpen(false);
    } else {
      setMenuOpen(true);
    }
  }

  //----- LINKS -----//

  const navigate = useNavigate();

  const goToHomepage = () => {
    navigate('/homepage');
  }

  const goToProfile = () => {
    navigate('/userProfile');
  }

  const goToMyRoba = () => {
    navigate('/myRoba');
  }

  const goToMyExchanges = () => {
    navigate('myExchanges');
  }

  //-----//

  // ----- FUNZIONE DI LOGOUT ----- //


  const handleLogout = () => {
    localStorage.removeItem('loggedUser');
    onLogout();
    navigate('/');
  }


  // ----- //

  //----- GESTISCO I DATI USER PER UserHeader -----//

  const token = localStorage.getItem('loggedUser');
  const decodedToken = jwtDecode(token);
  console.log('decodedToken ', decodedToken);

  //-----//

  //---- CHIAMATA DI CONTEGGIO OGGETTI UNTETE PICKATI PER NOTIFICA -----//

  const [pickedObjectCount, setPickedObjectCount] = useState(0);

  const getCount = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/userExchanges/pickedNumber/${decodedToken.id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if(response.ok) {
        const pickedNumber = await response.json();
        setPickedObjectCount(pickedNumber.payload);
      } else {
        console.log('Errore: ', response);
      }
    } catch (error) {
      console.log('Error Type: ', error);
    }
  }

    useEffect(() => {
      getCount();
    }, [])

    useEffect(() => {
      console.log('pickedObjectCount: ', pickedObjectCount);
    }, [pickedObjectCount])


  //-----//

  return (

    <div className="navbar-container">

      <div className="desktop-main">
      <img src={logo} className="navbar-logo" />
        <ul>
          <li onClick={goToHomepage}>Home</li>
          <li onClick={goToProfile}>Il mio profilo</li>
          <li onClick={goToMyRoba}>{pickedObjectCount !== 0 && <div className="notify">{pickedObjectCount}</div>}La mia ROBA</li>
          <li onClick={goToMyExchanges}>I miei scambi</li>
          <li>Assistenza</li>
          <li onClick={handleLogout}>Logout</li>
        </ul>
        <MiniUser user={{
          name: decodedToken.name,
          surname: decodedToken.surname,
          avatarUrl: decodedToken.avatar.url
        }} />
      </div>

      <div className="mobile-main">

        <div className={menuOpen ? 'closed-menu hidden' : 'closed-menu'} onClick={handleOpenMenu}>
          <div className="line-icon"></div>
          <div className="line-icon"></div>
          <div className="line-icon"></div>
        </div>

        <div className={menuOpen ? 'opened-menu' : 'opened-menu hidden'} onClick={handleOpenMenu}>
          <div className="close-up">
            <div className="angled-line-icon-1"></div>
            <div className="angled-line-icon-2"></div>
          </div>
          <ul>
            <li onClick={goToHomepage}>Home</li>
            <li onClick={goToProfile}>Il mio profilo</li>
            <li onClick={goToMyRoba}>{pickedObjectCount !== 0 && <div className="notify">{pickedObjectCount}</div>}La mia ROBA</li>
            <li onClick={goToMyExchanges}>I miei scambi</li>
            <li>Assistenza</li>
            <li onClick={handleLogout}>Logout</li>
          </ul>
        </div>

        <img src={logo} className="navbar-logo" />

        <MiniUser user={{
          avatarUrl: decodedToken.avatar.url
        }} />

      </div>
    </div>
    )
}

export default Navbar;
